import { SingletonFlowchart } from "../nodes/_service/singletonFlowchart"
import Writer from "../nodes/_service/singletonTools/writerStructureEnginnering"

const VisibleControl = {
  setByMapping(mapping, value){
    Writer.setWithMapping(mapping, value)
    this.updateVisible()
  },
  setByPropertie(prop){
    Writer.setWithProperty(prop)
    this.updateVisible()
  },
  updateVisible(){
    SingletonFlowchart.Memory.memory.forEach(n => {
      n.visibleApply()
    })
  }
}

export default VisibleControl